import React, { useState } from "react";

import { TableRow, Table, TableHead, TableBody, TableContainer, Paper, TableCell } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';
import { useParams } from "react-router-dom";

import ActivityService from "./Locality/Service/activityService";

import { Grid } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';

import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { formatDate } from "../../utils/dateFormat";

import { withStyles, makeStyles } from '@material-ui/core/styles';

import StudentService from "./Locality/Service/studentService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import FilterPanel, { FilterSection } from "../../components/ui/FilterPanel";
import { Box, Button, FormControl, InputAdornment, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import SearchIcon from "@material-ui/icons/Search";
import SchoolIcon from "@material-ui/icons/School";
import PersonIcon from "@material-ui/icons/Person";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1a1a1aad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function StudentDetails(props, history) {
    const { id } = useParams();

    const tableHeaders = ['Class','Section','Student Name','Date Of Birth' ,'Current Age' ];
    const classes = useStyles();
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [filtersOpen, setFiltersOpen] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterClassId, setFilterClassId] = useState("");
    const [filterSectionId, setFilterSectionId] = useState("");
    const [addClassList, setAddClassList] = useState([]);
    const [filterSectionList, setFilterSectionList] = useState([]);
    const idOf = (v) => (v && typeof v === "object" ? String(v._id || "") : String(v || ""));
    const loadFilterSections = (classId) => {
        if (!classId) {
            setFilterSectionList([]);
            return;
        }
        const ud = JSON.parse(localStorage.getItem("userDetail") || "{}");
        SectionService.findSectionList({ schooleId: ud.schooleId, classId })
            .then((res) => setFilterSectionList(Array.isArray(res) ? res : []))
            .catch(() => setFilterSectionList([]));
    };
    const onFilterClassChange = (e) => {
        setFilterClassId(e.target.value);
        setFilterSectionId("");
        loadFilterSections(e.target.value);
        setpg(0);
    };
    const handleResetFilters = () => {
        setFilterClassId("");
        setFilterSectionId("");
        setFilterSectionList([]);
        setSearchTerm("");
        setpg(0);
    };
    const [addUserPermitionsList, setUserPermitionsList] = useState({studentDetailsEdit:false, studentDetailsDelete:false});
    const [student, setStudent] = useState({
        classId: '',
        teacherName: '',
        email: '',
        subject: '',
        qualification: '',
        address: '',
        mobileNumber: '',
        attendence: '',
        status: '',
    });
    const handleChangePage=(event, newpage) =>{
        setpg(newpage);
    }
  
    const handleChangeRowsPerPage=(event)=> {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    useEffect(() => {
        // getTeacherList();
        getStudentList();
        getUserPermitionsList();
        const ud = JSON.parse(localStorage.getItem("userDetail") || "{}");
        AddClassService.getAllAddClass(ud.schooleId)
            .then((res) => setAddClassList(Array.isArray(res) ? res : []))
            .catch(() => setAddClassList([]));
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setStudentList([]);
            setUserPermitionsList({})
            // setClassNameList([]);
        }
    }, []);
    const handleOpen = () => {
        props.history.push('/app/studentregistration/add') 
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
    // const getTeacherList = () => {
    //     TeacherService.getAllTeacher().then((res) => {
    //         setTeacherList(res);
    //     }).catch((err) => {
           
    //     });
    // }
    const getUserPermitionsList=()=>{
        const userPermitions= ActivityService.userPermitions();
             setUserPermitionsList(userPermitions);
        }
        function diffDate(date1, date2) {
            var daysDiff = Math.ceil((Math.abs(date1 - date2)) / (1000 * 60 * 60 * 24));
            var years = Math.floor(daysDiff / 365.25);
            var remainingDays = Math.floor(daysDiff - (years * 365.25));
            var months = Math.floor((remainingDays / 365.25) * 12);
            var days = Math.ceil(daysDiff - (years * 365.25 + (months / 12 * 365.25)));
          
            return {
              daysAll: daysDiff,
              years: years,
              months: months,
              days: days
            }
          }
    const getStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        StudentService.getAllStudent(userDetails.schooleId).then((res) => {
            const parseJSONObject = res.map(obj => {
                obj.studentAge = `${diffDate(new Date(obj.dob), new Date()).years} Years  ${diffDate(new Date(obj.dob), new Date()).months} Months `;
               
                return obj;
              }
              );
           
            setStudentList(parseJSONObject);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editStudent = (id) => {
        // teacher.classId = teacher.classId ? teacher.classId._id :'';
        props.history.push(`/app/studentregistration/${id}`);
        // setStudent(student);
        // handleOpen();
    }
    const deleteStudent= (studentdelete) => {
        if (studentdelete) {
            StudentService.deleteStudent(studentdelete).then((res) => {
                getStudentList();
            }).catch((err) => {
            });
        }
    };
    const formik = useFormik({
        initialValues: student,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
        //   StudentService.upadeStudent(values).then((res) => {
        //     alert(" Updated Successfully.");
        //   })
        //     .catch((err) => {
        //       alert(err.response.data.message)
        //     })
        },
      });
    const filteredStudents = studentList.filter((st) => {
        if (filterClassId && idOf(st.classId) !== String(filterClassId)) return false;
        if (filterSectionId && idOf(st.sectionId) !== String(filterSectionId)) return false;
        const term = searchTerm.trim().toLowerCase();
        if (!term) return true;
        return `${st.firstName || ""} ${st.lastName || ""}`.toLowerCase().includes(term);
    });
    const activeFilterCount = [filterClassId, filterSectionId].filter(Boolean).length;

    return (
        <>
            <PageTitle title="Class  Reports"  />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                                                                        <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" p={2} style={{ gap: 10 }}>
                            <Typography variant="body2" style={{ color: '#444', fontWeight: 600 }}>
                                {filteredStudents.length} {filteredStudents.length === 1 ? 'Student' : 'Students'}
                            </Typography>
                            <Box display="flex" alignItems="center" style={{ gap: 10 }}>
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search by student name..."
                                    value={searchTerm}
                                    onChange={(e) => { setSearchTerm(e.target.value); setpg(0); }}
                                    style={{ minWidth: 240 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon fontSize="small" style={{ color: '#8a8a8a' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button
                                    variant="outlined"
                                    startIcon={<FilterListIcon fontSize="small" />}
                                    onClick={() => setFiltersOpen((o) => !o)}
                                    aria-pressed={filtersOpen}
                                    style={filtersOpen ? { backgroundColor: '#e6e6e6' } : undefined}
                                >
                                    Filters
                                    {activeFilterCount > 0 && (
                                        <span style={{ marginLeft: 8, padding: '1px 10px', border: '1px solid #c4c4c4', borderRadius: 12, fontSize: '0.72rem', fontWeight: 700, background: '#fff' }}>
                                            {activeFilterCount}
                                        </span>
                                    )}
                                </Button>
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="stretch" flexWrap="wrap">
                        <Box flex="1 1 520px" minWidth={0}>
                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                            <TableHead >
                            <TableRow>
                  {tableHeaders.map(key => (
                    <StyledTableCell key={key}>{key}</StyledTableCell>
                  ))}
                </TableRow>         
                            </TableHead>
                            <TableBody>
                                {filteredStudents.slice(pg * rpg, pg * rpg + rpg).map((student) => (
                                    <TableRow key={student._id}>
                                        <TableCell className="pl-3 fw-normal" >{student.classId ? student.classId.className : ''}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.sectionId?.sectionName || '—'}</TableCell>

                                         <TableCell className="pl-3 fw-normal" >
                                            {student.firstName }&nbsp; 
                                        {student.lastName } 
                                        </TableCell>
                                        {/* <TableCell className="pl-3 fw-normal" >{student.studentName}</TableCell> */}
                                        {/* <TableCell className="pl-3 fw-normal" >{student.classId ? student.classId.className:""}</TableCell> */}
                                        <TableCell className="pl-3 fw-normal" >{formatDate(student.dob)}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.studentAge}</TableCell>          
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer >
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 100000]}
                            count={filteredStudents.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                        </Box>
                        {filtersOpen && (
                            <FilterPanel onReset={handleResetFilters}>
                                <FilterSection title="Class" icon={<SchoolIcon style={{ fontSize: 16 }} />}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <Select displayEmpty value={filterClassId} onChange={onFilterClassChange}>
                                            <MenuItem value=""><em>All Classes</em></MenuItem>
                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </FilterSection>
                                <FilterSection title="Section" icon={<PersonIcon style={{ fontSize: 16 }} />}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!filterClassId || filterSectionList.length === 0}>
                                        <Select
                                            displayEmpty
                                            value={filterSectionId}
                                            onChange={(e) => { setFilterSectionId(e.target.value); setpg(0); }}
                                        >
                                            <MenuItem value=""><em>All Sections</em></MenuItem>
                                            {filterSectionList.map(({ _id, sectionName }) => (
                                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </FilterSection>
                            </FilterPanel>
                        )}
                        </Box>
                    </Widget>
                </Grid>
            </Grid>
            
        </>
    );
}


